/**
 * ProgressBar.tsx
 * ---------------
 * Visual progress bar component.
 * - Accepts progress (0-1) and optional color class.
 * - Accessible with ARIA attributes.
 */


import React from 'react';

interface ProgressBarProps {
  progress: number; // 0 to 1
  colorClass?: string; // Tailwind color class, e.g. 'bg-blue-500', 'bg-purple-500'
}

const ProgressBar: React.FC<ProgressBarProps> = ({ 
  progress, colorClass = 'bg-blue-500' 
}) => (
<div className="relative w-full">
  <progress
    value={progress * 100}
    max={100}
    aria-label="Course progress"
    className="absolute w-full h-4 opacity-0 pointer-events-none"
  />
    <div className="w-full bg-gray-200 rounded-full h-4">
      <div
        className="h-4 rounded-full bg-blue-500 transition-all duration-300"
        style={{ width: `${progress * 100}%` }}
      />
    </div>
</div>
);

export default ProgressBar;
